"use strict";

/* Controllers */
_BannerFlowApp.controller("ErrorDialogController", function ErrorDialogController($scope) {
    $scope.model = {
        bannerFlowRequestId: $scope.ngDialogData.data
    };

    $scope.reload = function () {
        window.location.reload();
    };

    $scope.close = function () {
        $scope.closeThisDialog();
    };

    $scope.contactUs = function (bannerflowErrorId) {
        $scope.close();
        Intercom(
            "showNewMessage",
            "--------------💥error info💥-------------\n" +
                bannerflowErrorId +
                "\n" +
                location.href +
                "\n----------💥end error info💥----------\n\n" +
                "I received an error, can you please help?"
        );
    };
});
